export const phones = [
    {
        id:1,
        name:'John Doe', 
        avatar:'/images/avatars/Vector-1.png',
        status:'incoming',
        date:'5 May, 2023, 06:21',
        duration:'5:37',
        type:'phone',
      },
      {
        id:2,
        name:'Jake Doe', 
        avatar:'/images/avatars/Vector-2.png',
        status:'incoming',
        date:'6 May, 2023, 07:33',
        duration:'6:98',
        type:'video',
        group: true ,
      },
      {
        id:3,
        name:'Jane Doe', 
        avatar:'/images/avatars/Vector-3.png',
        status:'outgoing',
        date:'3 May, 2023, 17:44',
        duration:'1:23',
        type:'phone',
      },
      {
        id:4,
        name:'Jessica Doe', 
        duration:'3:59',
        avatar:'/images/avatars/Vector-4.png',
        status:'incoming',
        date:'5 May, 2023, 15:23',
        type:'video',
        group: true ,
      },
      {
        id:5,
        name:'Janice Doe', 
        duration:'8:42',
        avatar:'/images/avatars/Vector-5.png',
        status:'outgoing',
        date:'5 May, 2023, 15:57',
        type:'video',
      },
      {
        id:6,
        name:'James Doe', 
        duration:'8:53',
        color:'#22c55e',
        status:'incoming',
        date:'1 May, 2023, 11:14',
        type:'video',
        group: true ,
      },
      {
        id:6,
        name:'Joe Doe', 
        duration:'4:37',
        color:'#a855f7',
        status:'outgoing',
        date:'1 May, 2023, 15:52',
        type:'phone',
      },
      {
        id:7,
        name:'Jennie Doe', 
        duration:'1:34',
        color:'#eab308',
        status:'outgoing',
        date:'1 May, 2023, 17:36',
        type:'phone',
       },
       {
        id:8,
        name:'Javelin Doe', 
        duration:'8:23',
        color:'#a855f7',
        status:'incoming',
        date:'25 Apr, 2023, 09:12',
        type:'phone',
        group: true ,
      },
      {
        id:9,
        name:'Jack Doe', 
        duration:'2:36',
        avatar:'/images/avatars/Vector-10.png',
        status:'outgoing',
        date:'21 Apr, 2023, 13:25',
        type:'phone',
      },
      
      
      
]